import { initializeApp } from 'firebase/app';
import { getAuth, signInWithPopup, GoogleAuthProvider, FacebookAuthProvider } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getAnalytics, setAnalyticsCollectionEnabled, setConsent } from 'firebase/analytics';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASEURL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
    appId: process.env.REACT_APP_FIREBASE_APPID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENTID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const auth = getAuth(app);
const db = getDatabase(app);
let analytics = null;

// Function to initialize analytics based on consent
export const initializeAnalytics = (preferences) => {
    if (typeof window === 'undefined') return;

    try {
        if (preferences.analytics) {
            analytics = getAnalytics(app);
            setAnalyticsCollectionEnabled(analytics, true);
            setConsent({
                analytics_storage: "granted",
                functionality_storage: "granted",
                security_storage: "granted",
                ad_storage: preferences.marketing ? "granted" : "denied",
                personalization_storage: preferences.marketing ? "granted" : "denied"
            });
        } else if (analytics) {
            setAnalyticsCollectionEnabled(analytics, false);
        }
    } catch (error) {
        console.warn('Analytics initialization failed:', error);
    }
};

export const signInWithGoogle = async () => {
    const provider = new GoogleAuthProvider();
    try {
        const result = await signInWithPopup(auth, provider);
        console.log('Google Sign-In successful:', result.user);
        return result.user;
    } catch (error) {
        console.error('Google Sign-In error:', error);
        throw error;
    }
};

export const signInWithFacebook = async () => {
    const provider = new FacebookAuthProvider();
    try {
        const result = await signInWithPopup(auth, provider);
        console.log('Facebook Sign-In successful:', result.user);
        return result.user;
    } catch (error) {
        console.error('Facebook Sign-In error:', error);
        throw error;
    }
};

export { auth, db, analytics };